import {ProfileModel} from '../../model'
import {aditionalValues} from '../../../../util/utilitario'
export const initValues: ProfileModel = {
  id: '',
  nombre: '',
  aplicacionId: '',
  ...aditionalValues,
}
